<template src="./verify.html"></template>

<script>
import axios from 'axios'
  export default {
    data: function () {
      return {
        token: null,
        password: '',
        password_confirmation: '',
        loading: false
      }
    },
    methods: {
      verify: function () {
        if (!this.password || !this.password_confirmation) {
          this.errorNotification('Please fill in all fields')
          return
        }
        
        if (this.password !== this.password_confirmation) {
          this.errorNotification('Passwords do not match')
          return
        }
        
        if (this.password.length < 6) {
          this.errorNotification('Password must be at least 6 characters long')
          return
        }
        
        this.loading = true
        
        axios.post('/api/auth/verify', {
          token: this.token,
          password: this.password
        }).then(response => {
          // Log the user in (store token and update store so auth guard allows access)
          localStorage.setItem('token', response.data.token)
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + response.data.token
          this.$store.commit('user/setLoggedIn')
          
          this.swal({
            type: 'success',
            title: 'Account Verified!',
            text: 'Your account has been verified successfully. Complete the steps below to set up your account.'
          }).then(() => {
            this.$router.push('/onboarding/welcome')
          })
        }).catch(error => {
          if (error.response && error.response.data && error.response.data.error) {
            this.errorNotification(error.response.data.error)
          } else {
            this.errorNotification('Failed to verify account. Please try again.')
          }
        }).finally(() => {
          this.loading = false
        })
      }
    },
    created: function () {
      // `t` = short opaque token (email); `token` = legacy JWT links
      this.token = this.$route.query.t || this.$route.query.token
      if (!this.token) {
        this.errorNotification('Invalid verification link')
        this.$router.push('/login')
      }
    }
  }
</script>

<style scoped>
  .field {
    margin-bottom: 1.5rem;
  }
</style>
